import { gql } from "@apollo/client";

export const FETCH_ACTIVITIES_QUERY = gql`
  query UserFeedRecords($first: Int!, $skip: Int!, $filterString: String, $searchString: String) {
    userFeedRecords(first: $first, skip: $skip, filterString: $filterString, searchString: $searchString) {
      userFeed {
        hasAccess
        createdTs
        id
        isRead
        isReply
        isFolder
        isSubFile
        isMention
        isComment
        isDocument
        isNewField
        previousFolder
        subFile {
          id
          title
        }
        document {
          id
          title
          inTrash
          isArchive
          folder {
            id
            title
            inTrash
            isArchive
            parentFolder {
              id
            }
          }
        }
        folder {
          id
          title
          inTrash
          isArchive
          isRoot
          parentFolder {
            id
          }
        }
        feedActivity {
          name
        }
        createdBy {
          firstName
          lastName
          email
          profile {
            image
            role {
              name
            }
          }
        }
        comment {
          note
          mentionedList
          parentComment {
            note
            mentionedList
          }
          document {
            id
            title
            inTrash
          }
        }
      }
      unreadCount
    }
  }
`;

export const MARK_ACTIVITIES_READ = gql`
  mutation MarkAsRead($feedIds: [UUID], $markAll: Boolean) {
    markAsRead(feedIds: $feedIds, markAll: $markAll) {
      success
    }
  }
`;
